import { css } from 'lit';

export const customerWorkspacePageStyles = css`
  .history {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .history li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2);
    padding: var(--space-2) 0;
    border-top: var(--border-width) solid var(--border);
  }

  .history li:first-child {
    border-top: 0;
  }

  .current {
    font-weight: var(--font-weight-semibold);
  }

  dl.facts {
    margin-top: var(--space-3);
  }

  .persona + .persona {
    margin-top: var(--space-3);
  }

  .persona h3 {
    margin: 0 0 var(--space-1);
    font-size: var(--font-size-ui);
  }

  .steps {
    margin: 0;
    padding-left: var(--list-indent);
  }

  .steps li + li {
    margin-top: var(--space-2);
  }

  .identity {
    display: flex;
    align-items: center;
    gap: var(--space-4);
    margin-bottom: var(--space-3);
  }

  .identity h3 {
    margin: 0;
    font-size: var(--font-size-lg);
  }

  .requests {
    list-style: none;
    margin: var(--space-2) 0 0;
    padding: 0;
  }

  .requests li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2);
    padding: var(--space-2) 0;
    border-top: var(--border-width) solid var(--border);
  }

  .requests code {
    font-size: var(--font-size-base);
    letter-spacing: var(--tracking-wider);
  }

  .avatar {
    flex: none;
    width: var(--avatar-size);
    height: var(--avatar-size);
    border-radius: var(--radius-round);
    border: var(--border-width) solid var(--border-strong);
    object-fit: cover;
  }
`;
